<div *ngIf="value > 0" class="notification-badge">{{value}}</div>
